/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ProjectFile } from './projectFile';
import { User } from './user';

export interface BIMBaseCheck { 
    id?: string;
    uuid?: string;
    checkDate?: Date;
    projectFile?: ProjectFile;
    checker?: User;
    results?: string;
    completed?: boolean;
    nextPollAt?: Date;
    pollCount?: number;
    checkType?: BIMBaseCheck.CheckTypeEnum;
    projectID?: number;
}
export namespace BIMBaseCheck {
    export type CheckTypeEnum = 'QUALITY' | 'HOAI' | 'IFC' | 'BASE' | 'SWM' | 'MY_CHECK';
    export const CheckTypeEnum = {
        QUALITY: 'QUALITY' as CheckTypeEnum,
        HOAI: 'HOAI' as CheckTypeEnum,
        IFC: 'IFC' as CheckTypeEnum,
        BASE: 'BASE' as CheckTypeEnum,
        SWM: 'SWM' as CheckTypeEnum,
        MYCHECK: 'MY_CHECK' as CheckTypeEnum
    };
}